import styled from "styled-components";

export const BigText = styled.div`
	color: #000;
	font-size: 30px;
	font-weight: 600;
`;

export const PrimaryText = styled.span`
    font-weight: 700;
	font-size: 16px;
	color: #f2f2f2;
	text-align:left;
`;

export const PrimaryTextLight = styled.span`
    font-weight: 400;
	font-size: 16px;
	color: #d6d6d6;
	text-align:left;
`;

export const SecondaryTextBright = styled.span`
    font-weight: 400;
	font-size: 14px;
	color: #D6D6D6;
	text-align:left;
`;

export const SecondaryText = styled.span<any>`
    font-weight: 400;
	font-size: ${props => props.fontSize || "14px"};
	color: #A8A8A8;
	text-align:left;
`;

export const TertiaryText = styled.div`
    font-weight: 400;
	font-size: 12px;
	color: #b6b6b6;
	text-align:left;
`;